import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import _imports_0 from '../../assets/min-main-logo.png';
var _hoisted_1 = { class: "back-button" };
var _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", { class: "home-logo" }, [
    /*#__PURE__*/ _createElementVNode("img", {
        src: _imports_0,
        alt: ""
    })
], -1);
var _hoisted_3 = { class: "main-title" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _component_ArrowLeftBold = _resolveComponent("ArrowLeftBold");
    var _component_el_icon = _resolveComponent("el-icon");
    var _component_router_link = _resolveComponent("router-link");
    var _component_Map = _resolveComponent("Map");
    var _component_BaseLayout = _resolveComponent("BaseLayout");
    return (_openBlock(), _createBlock(_component_BaseLayout, { class: "find-bike-lane" }, {
        header: _withCtx(function () { return [
            _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_el_icon, { onClick: _ctx.goBack }, {
                    default: _withCtx(function () { return [
                        _createVNode(_component_ArrowLeftBold)
                    ]; }),
                    _: 1
                }, 8, ["onClick"])
            ]),
            _createVNode(_component_router_link, { to: "/" }, {
                default: _withCtx(function () { return [
                    _hoisted_2
                ]; }),
                _: 1
            }),
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("p", null, _toDisplayString(_ctx.$route.params.routeName), 1)
            ])
        ]; }),
        body: _withCtx(function () { return [
            _createVNode(_component_Map, {
                bikeLaneGeomery: _ctx.bikeLaneGeomery,
                laneCenter: _ctx.laneCenter,
                starAndEnd: _ctx.starAndEnd,
                zoom: _ctx.laneDistance
            }, null, 8, ["bikeLaneGeomery", "laneCenter", "starAndEnd", "zoom"])
        ]; }),
        _: 1
    }));
}
